import { render, staticRenderFns } from "./54-voice.vue?vue&type=template&id=ec2148ec&scoped=true"
import script from "./54-voice.vue?vue&type=script&lang=js"
export * from "./54-voice.vue?vue&type=script&lang=js"
import style0 from "./54-voice.vue?vue&type=style&index=0&id=ec2148ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.90.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2148ec",
  null
  
)

export default component.exports